<div>
  @if (display) {
    <div>
      @if (hidePage) {
        <div class="container">
          <div class="header-wrapper" style="width: 100%" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="logo">
              <calsoft-logo [sitename]="data.siteName" [type]="'dark'"></calsoft-logo>
            </div>
            <div fxLayout="row" fxFlex="90">
              @if (showMenu) {
                <mat-toolbar-row fxHide fxShow.gt-sm class="container" fxLayout="row" fxLayout.xs="row"
                  fxLayoutAlign="space-between center" style="color: #000000;margin: 0px;padding: 0 25px;">
                  <calsoft-Menu [newcolor]="true" [color]="true" [data]="data" [type]="'one'" style="color: #000000;"
                    class="menu" [categoryArray]="item"></calsoft-Menu>
                </mat-toolbar-row>
              }
            </div>
          </div>
        </div>
      }
      @if (!hidePage) {
        <div class="header container">
          <div class="header-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <calsoft-logo [sitename]="data.siteName" [type]="'white'"></calsoft-logo>
            </div>
            <div fxLayout="row" fxFlex="90">
              @if (showMenu) {
                <mat-toolbar-row fxHide fxShow.gt-sm class="container" fxLayout="row" fxLayout.xs="row"
                  fxLayoutAlign="space-between center" style="margin: 0px;padding: 0 25px;">
                  <calsoft-Menu [color]="true" [data]="data" [type]="'one'" style="color: #000000;" class="menu"
                    [categoryArray]="item"></calsoft-Menu>
                </mat-toolbar-row>
              }
            </div>
          </div>
        </div>
      }
      <!-- Fixed toolbar section - fixed error here -->
      <mat-toolbar    [class.active]="showFixedHeader"  style="z-index: 1000;width: 100%;background-color: white;" fxHide fxShow.gt-md fxShow.md
        class="calsoft-fixed-header bg toolbar-container" fxLayout="row" [ngClass]="{ 'toolbar-30': !showMenu }">
        <mat-toolbar-row class="header-wrapper container" style="width: 100%;height: 100%;" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="logo">
            <calsoft-logo [sitename]="data.siteName" [type]="'dark'"></calsoft-logo>
          </div>
          <div fxLayout="row" fxFlex="90">
            @if (showMenu) {
              <div fxHide fxShow.gt-sm class="container" 
                   fxLayout="row" fxLayout.xs="row"
                   fxLayoutAlign="space-between center" 
                   style="margin: 0px;padding: 0 10px;">
                <calsoft-Menu [newcolor]="true" [color]="true" [data]="data" [type]="'one'" 
                  style="color: #000000;" class="menu" [categoryArray]="item"></calsoft-Menu>
              </div>
            }
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>
  }
  @if (!display) {
    <div>
    @if (mobileHeaderType==8) {
      <div>
        <calsoft-mobile-header9 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header9>
      </div>
    }
  </div>
  }
</div>